import { isEmpty } from "lodash-es";
import { getCookie } from "./utils";

enum HeimdallIds {
  REFERRER = '__tt_heimdall_referrer',
}

const getHeimdallTrackingInfo = () => {
  const ttHeimdallReferrer = getCookie(HeimdallIds.REFERRER);
  if (isEmpty(ttHeimdallReferrer)) {
    return {}
  }
  return {
    ttHeimdallReferrer
  };
};

export { getHeimdallTrackingInfo };
